var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCaseSwift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_601_4646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.89102 0H31.0473C32.1254 0 33.1723 0.171875 34.1879 0.53125C35.6566 1.0625 36.9848 2 37.9848 3.21875C39.0004 4.4375 39.6723 5.9375 39.9066 7.5C40.0004 8.07812 40.016 8.65625 40.016 9.23438V30.8438C40.016 31.5312 39.9848 32.2344 39.8441 32.9062C39.5316 34.4531 38.7973 35.9062 37.7348 37.0781C36.6879 38.25 35.3129 39.125 33.8285 39.5938C32.9223 39.875 31.9848 40 31.0316 40C30.6098 40 8.82852 40 8.50039 39.9844C6.90664 39.9062 5.32852 39.3906 4.00039 38.5C2.70352 37.625 1.64102 36.4062 0.953517 35C0.359768 33.7969 0.0628926 32.4531 0.0628926 31.1094V8.89062C0.0316426 7.5625 0.312893 6.25 0.891017 5.0625C1.56289 3.65625 2.60977 2.42188 3.90664 1.54688C5.23477 0.640625 6.79727 0.109375 8.39102 0.03125C8.54727 0 8.71914 0 8.89102 0Z",
    fill: "url(#paint0_linear_601_4646)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.75 32.7188C33.6094 32.5 33.4531 32.2812 33.2813 32.0781C32.8906 31.6094 32.4375 31.2031 31.9375 30.8594C31.3125 30.4375 30.5781 30.1719 29.8281 30.1406C29.2969 30.1094 28.7656 30.2031 28.2656 30.3906C27.7656 30.5625 27.2813 30.8125 26.8125 31.0625C26.2656 31.3438 25.7188 31.625 25.1406 31.8594C24.4531 32.1406 23.7344 32.3594 23 32.5156C22.0781 32.6875 21.1406 32.75 20.2188 32.7344C18.5469 32.7031 16.875 32.4531 15.2813 31.9844C13.875 31.5625 12.5313 30.9844 11.2656 30.25C10.1563 29.6094 9.125 28.875 8.15625 28.0469C7.35938 27.3594 6.625 26.625 5.9375 25.8438C5.46875 25.2969 5.01563 24.7187 4.59375 24.125C4.42188 23.8906 4.26563 23.6406 4.125 23.3906L0 18.9375V8.85938C0 3.96875 3.95313 0 8.84375 0H16.7344L22.5781 5.9375C35.7656 14.9062 31.5 24.7969 31.5 24.7969C31.5 24.7969 35.25 29.0156 33.75 32.7188Z",
    fill: "url(#paint1_linear_601_4646)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6094 5.9375C35.7969 14.9062 31.5313 24.7969 31.5313 24.7969C31.5313 24.7969 35.2813 29.0312 33.7656 32.7344C33.7656 32.7344 32.2188 30.1406 29.625 30.1406C27.125 30.1406 25.6562 32.7344 20.625 32.7344C9.42188 32.7344 4.125 23.375 4.125 23.375C14.2188 30.0156 21.1094 25.3125 21.1094 25.3125C16.5625 22.6719 6.89062 10.0469 6.89062 10.0469C15.3125 17.2188 18.9531 19.1094 18.9531 19.1094C16.7812 17.3125 10.6875 8.53125 10.6875 8.53125C15.5625 13.4688 25.25 20.3594 25.25 20.3594C28 12.7344 22.6094 5.9375 22.6094 5.9375Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_601_4646",
    x1: 23.7959,
    y1: -1.42734,
    x2: 16.2385,
    y2: 41.4322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAE42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF3E31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_601_4646",
    x1: 20.4081,
    y1: 0.64625,
    x2: 14.877,
    y2: 32.0145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E39F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D33929"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_601_4646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseSwift);
export default __webpack_public_path__ + "static/media/case_swift.d8ac66f4ee02ffeee7e56171d5e551ac.svg";
export { ForwardRef as ReactComponent };